@use 'themes/westfield' as *;
@use 'tools/color' as *;
@use 'tools/dirg' as *;

.appleButton {
  border: color('borderPrimary') solid 1px;
  height: 48px;
  font-size: 16px;
  background-color: color('surfaceTertiary');
  color: color('textPrimary');
  text-transform: none;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-font-smoothing: initial;
  -moz-osx-font-smoothing: initial;
}

.signinWithApple {
  margin-left: 16px;
}
